import { catchError, from, map, Observable, of } from 'rxjs';
import { concatMap, tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ClientConfigurationInterface, ClientConfigurationManager } from './client-configuration-manager';
import { LogService } from '../log/log.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { LocalstorageHelper } from '../storage/localstorage-helper';
import { SerializabledDataType } from '@nts/std/types';

@Injectable({
  providedIn: 'root',
})
export class ClientConfigurationLoader {
  static readonly LOCAL_STORAGE_CONFIGURATION_KEY = 'configuration';

  constructor(
    private localStorageService: LocalStorageService
  ) { }

  getConfiguration(): Observable<ClientConfigurationInterface> {
    return from(this.localStorageService.init()).pipe(
      concatMap(() =>
        from(
          LocalstorageHelper.getStorageItem({
            key: ClientConfigurationLoader.LOCAL_STORAGE_CONFIGURATION_KEY,
            tenantBarrier: false,
          })
        )
      ),
      map((value: SerializabledDataType) => this.toClientConfiguration(value)),
      tap((config) => {
        ClientConfigurationManager.Current.config = config;
        ClientConfigurationManager.Current.loaded.next(true);
      }),
      catchError((err) => {
        LogService.debug(err);
        const emptyConfig = {} as ClientConfigurationInterface;
        ClientConfigurationManager.Current.config = emptyConfig;
        ClientConfigurationManager.Current.loaded.next(true);
        return of(emptyConfig);
      })
    );
  }

  private toClientConfiguration(
    value: SerializabledDataType
  ): ClientConfigurationInterface {
    if (this.isRecord(value)) {
      return value as ClientConfigurationInterface;
    }

    return {} as ClientConfigurationInterface;
  }

  private isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
  }
}
